'use client'

import useFetch from '@hooks/useFetch'
import useTrackProperty from '@hooks/useTrackProperty'
import { getToken } from '@plugin/login'
import classNames from 'classnames'
import { assign, get, isFunction } from 'lodash-es'
import { createContext, useCallback, useContext } from 'react'

const TrackButtonContext = createContext()
export default function TrackButton({
  data,
  signupSource,
  className,
  dark = false,
  content,
  onClick,
  buttonDisplay = true
}) {

  const { tracked, tracking, handleClick } = useTrackButton({
    data,
    signupSource,
    onClick
  })

  return (
    <TrackButtonContext.Provider value={{ tracked, tracking }}>
      <button
        type='button'
        className={classNames(' pointer-events-auto', buttonDisplay && (tracked || dark ? 'button-orange' : 'button-primary-out'), className)}
        onClick={handleClick}
        aria-label='track property'
      >
        {
          content
            ? content
            : tracking ? 'loading...' : tracked ? 'Stop tracking' : 'Track property'
        }
      </button>
    </TrackButtonContext.Provider>
  )
}

export function TrackButtonResponsiveContent({
  mobileTrackText,
  mobileStopText,
  trackText,
  stopText
}) {
  const { tracked, tracking } = useContext(TrackButtonContext)

  return (
    <>
      <span className='hidden sm:block'>{tracking ? 'loading...' : tracked ? stopText : trackText}</span>
      <span className='sm:hidden'>{tracking ? 'loading...' : tracked ? mobileStopText : mobileTrackText}</span>
    </>
  )
}

export function useTrackButton({
  data,
  signupSource,
  onClick
}) {
  const { data: status } = useFetch(
    getToken()
      ? { url: 'property/user/state', params: { houseId: data.houseId, propertyId: data.propertyId }, cfCache: false }
      : null
  )
  const { showTrackProperty, tracking, trackedList } = useTrackProperty()

  const house = assign({}, data, status)
  const tracked = get(trackedList, data.propertyId, get(house, 'tracked', false))

  const handleClick = useCallback(event => {
    isFunction(onClick) && onClick()
    showTrackProperty({ house, signupSource })(event)
  }, [showTrackProperty, house, signupSource, onClick])

  return {
    tracked,
    tracking,
    handleClick
  }
}